import { useFieldArray } from "react-hook-form";
import { useEffect, useState } from "react";
import { CustomTextField, InputPropsStyleForInvoice } from "../../helper";
import addTicketStyles from "./AddTickets.module.css";
import { Close } from "@mui/icons-material";

const InputField = CustomTextField();

const TicketsList: React.FC<{ control: any; eventIndex: number, errors: any, watch: any, setValue: any, trigger: any }> = ({ control, eventIndex, errors, watch, setValue, trigger }) => {
    const { fields } = useFieldArray({
        control,
        name: `ticketDetails.${eventIndex}.tickets`
    });

    const handleChangeTicketDetails = (e: any, key: string) => {
        setValue(key, e.target.value);
        trigger();
    }
    return (
        <div>
            {fields.map((_ticket, ticketIndex) => (
                <div className={addTicketStyles.ticketDetail} key={`ticket_${ticketIndex}`}>
                    <div className={addTicketStyles.ticketContainer}>
                        <div className={addTicketStyles.ticketsubContainer}>
                            <div>Enter Section</div>
                            <div>
                                <InputField
                                    key={`ticketDetails.${eventIndex}.tickets.${ticketIndex}.section`}
                                    sx={{
                                        "& input": {
                                            height: "0.0375em",
                                            textTransform: "capitalize"
                                        },
                                    }}
                                    classes={{
                                        root: addTicketStyles.sectiondiv,
                                    }}
                                    {...control.register(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.section`, {
                                        required: "Section is required!",
                                        pattern: {
                                            value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                                            message: 'Enter valid section'
                                        },
                                        maxLength: {
                                            value: 32,
                                            message: "Maximum of 32 characters",
                                        },
                                    })}
                                    InputProps={{
                                        style: InputPropsStyleForInvoice,
                                    }}
                                     name={"section"}
                                    placeholder={`Enter section`}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeTicketDetails(e, `ticketDetails.${eventIndex}.tickets.${ticketIndex}.section`)}
                                    error={Boolean(errors?.ticketDetails?.[eventIndex]?.tickets?.[ticketIndex]?.section?.message)}
                                // onKeyDown={handleKeyDown}
                                />
                                <span className={addTicketStyles.errorMsgStyle}>
                                    {errors?.ticketDetails?.[eventIndex]?.tickets?.[ticketIndex]?.section?.message}
                                </span>
                            </div>
                        </div>




                        <div className={addTicketStyles.ticketsubContainer}>
                            <div>Enter Row</div>
                            <div>
                                <InputField
                                    key={`ticketDetails.${eventIndex}.tickets.${ticketIndex}.row`}
                                    sx={{
                                        "& input": {
                                            height: "0.0375em",
                                            textTransform: "capitalize"
                                        },
                                    }}
                                    classes={{
                                        root: addTicketStyles.sectiondiv,
                                    }}
                                    {...control.register(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.row`, {
                                        required: "Row is required!",
                                        pattern: {
                                            value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                                            message: 'Enter valid row'
                                        },
                                        maxLength: {
                                            value: 32,
                                            message: "Maximum of 32 characters",
                                        },
                                    })}
                                    InputProps={{
                                        style: InputPropsStyleForInvoice,
                                    }}
                                     name="row"
                                    placeholder={`Enter row`}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeTicketDetails(e, `ticketDetails.${eventIndex}.tickets.${ticketIndex}.row`)}
                                    error={Boolean(errors?.ticketDetails?.[eventIndex]?.tickets?.[ticketIndex]?.row?.message)}
                                // onKeyDown={handleKeyDown}
                                />
                                <span className={addTicketStyles.errorMsgStyle}>
                                    {errors?.ticketDetails?.[eventIndex]?.tickets?.[ticketIndex]?.row?.message}
                                </span>
                            </div>
                        </div>
                    </div>

                    <SeatNumbers control={control} eventIndex={eventIndex} ticketIndex={ticketIndex} errors={errors} watch={watch}
                      setValue={setValue} trigger = {trigger}/>

                    {/* <button type="button" onClick={() => append({ section: "", row: "", seatNo: [{ value: "" }] })} style={{ marginTop: "5px" }}>
                        Add Ticket
                    </button > */}
                </div>
            ))}
        </div>
    );
};

const SeatNumbers: React.FC<{ control: any; eventIndex: number; ticketIndex: number, errors: any, watch: any, setValue: any;trigger: any }> = ({
    control,
    eventIndex,
    ticketIndex,
    errors,
    watch,
    setValue,
    trigger
}) => {
    const [seatNoError, setSeatnoError] = useState("");
    const watchedFields = watch(['ticketDetails']);
    const seats = watch(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`) || [];
    useEffect(() => {
        if (errors?.ticketDetails) {
            const regex = /^[0-9]+(?: [0-9]+)*$/;

            const ticketValues = Object.values(errors.ticketDetails);
            const isErrorSeatLength = ticketValues.some((ticketvalue: any) => ticketvalue?.tickets.some((ticket: any) => ticket?.seatNo?.length === 0))
            // const isErrorSeatLength = ticketValues.some((ticket: any) => ticket?.seatNo?.length === 0);
            const isErrorSeatRegex = ticketValues.some((ticketValue: any) => ticketValue?.tickets.some((ticket: any) => ticket?.seatNo && !regex.test(ticket.seatNo)))
            // const isErrorSeatRegex = ticketValues.some((ticket: any) => ticket?.seatNo && !regex.test(ticket.seatNo));


            if (isErrorSeatLength) {
                setSeatnoError("Seat no is required!");
            } else if (isErrorSeatRegex) {
                setSeatnoError("Enter valid seat no!");
            } else {
                setSeatnoError("");
            }
        } else {
            setSeatnoError("");
        }
    }, [errors, watchedFields]);

    const handleRemoveSeat = (seatIndex: number) => {
        const updatedSeats = seats.filter((_: any, index: number) => index !== seatIndex);
        setValue(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`, updatedSeats);
        trigger();
    };
    return (
        <div className={addTicketStyles.seatNoContainer} key = {`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`}>
            <div>Enter Seat No</div>
            <div>
                <div className={addTicketStyles.seatNoDiv}>

                    {seats.map((_seat: any, seatIndex: number) => (
                        <div key ={`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo.${seatIndex}.value`}
                        className={addTicketStyles.seatInlineBlock}>
                            <InputField
                                key={`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo.${seatIndex}.value`}
                                sx={{
                                    "& input": {
                                        height: "0.0375em",
                                        textTransform: "capitalize",
                                    },
                                }}
                                classes={{
                                    root: addTicketStyles.seatnodiv,
                                }}
                                {...control.register(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo.${seatIndex}.value`, {
                                    required: "Seat no is required!",

                                    pattern: {
                                        value: /^[0-9]+(?: [0-9]+)*$/,
                                        message: 'Enter valid seat no'
                                    },
                                    maxLength: {
                                        value: 32,
                                        message: "Maximum of 32 digits are allowed",
                                    },
                                })}
                                InputProps={{
                                    style: InputPropsStyleForInvoice,
                                }}
                                value={seats[seatIndex]?.value || ""}
                                onChange={(e) => {
                                    const updatedSeats = [...seats];
                                    updatedSeats[seatIndex] = { value: e.target.value };
                                    setValue(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`, updatedSeats);
                                    trigger();
                                }}
    
                                error={Boolean(errors?.ticketDetails?.[eventIndex]?.tickets?.[ticketIndex]?.seatNo?.[seatIndex]?.message)}
                            // onKeyDown={handleSeatNoKeyDown}
                            />
                            {
                                seats.length > 1 && <Close 
                                onClick={() => handleRemoveSeat(seatIndex)}
                                className={addTicketStyles.closeSeat}
                            />
                            }
                        </div>
                    ))}
                    <div key = {`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`}>
                        <div key = {`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`} 
                            className={addTicketStyles.seatPlusbtn}
                            onClick={() => {
                                const updatedSeats = [...seats];
                                updatedSeats[seats.length] = { value: "" };
                                setValue(`ticketDetails.${eventIndex}.tickets.${ticketIndex}.seatNo`, updatedSeats);
                                trigger()
                            }}
                        >
                            <label className={addTicketStyles.plusLabelStyle}>+</label>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={addTicketStyles.errorMsgStyle} style = {{marginLeft: "10px"}}>
                        {seatNoError}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TicketsList;
